import { type ReactNode } from 'react';
import type { Editor } from '@tiptap/react';
import { type Cfg, MARK, HEADING, BLOCK } from './tiptap-toolbar-configs';

export type Item = {
  active: boolean;
  onClick: () => void;
  title: string;
  icon: ReactNode;
};

function build(e: Editor, c: Cfg): Item {
  return {
    active: e.isActive(c.mark),
    onClick: () => c.run(e),
    title: c.title,
    icon: c.icon,
  };
}

export const markItems = (e: Editor): Item[] => MARK.map((c) => build(e, c));

export const headingItems = (e: Editor): Item[] =>
  HEADING.map((c, i) => ({
    ...build(e, c),
    active: e.isActive('heading', { level: i + 2 }),
  }));

export const blockItems = (e: Editor): Item[] => BLOCK.map((c) => build(e, c));
